import { Text } from '@/components/ui/text';
import { authStore, toSession, verifyEmailToken } from '@/lib/auth/auth';
import { DESIGN_TOKENS } from '@/lib/design/theme';
import { router, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { ActivityIndicator, View } from 'react-native';

export default function VerifyEmailScreen() {
  const { token } = useLocalSearchParams<{ token?: string }>();
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!token) {
      setError('Invalid verification link.');
      return;
    }

    verifyEmailToken(token)
      .then((result) => {
        authStore.setState({ session: toSession(result) });
        router.replace('/(tabs)/events');
      })
      .catch(() => {
        setError('This verification link is invalid or has expired.');
      });
  }, [token]);

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: DESIGN_TOKENS.colors.canvas,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}>
      {error ? (
        <View style={{ alignItems: 'center', gap: 12 }}>
          <Text className="text-center text-primary">
            {error}
          </Text>
          <Text
            variant="muted"
            style={{ textAlign: 'center' }}
            onPress={() => router.replace('/sign-in')}>
            Back to sign in
          </Text>
        </View>
      ) : (
        <View style={{ alignItems: 'center', gap: 16 }}>
          <ActivityIndicator color={DESIGN_TOKENS.colors.accent} size="large" />
          <Text variant="muted">
            Verifying your email…
          </Text>
        </View>
      )}
    </View>
  );
}
